(function () {
  function permitted() {
    try {
      const page = document.querySelector('[data-rsd-page]');
      return localStorage.getItem('rsd_cookie_consent') === 'accepted' && (!page || page.dataset.themeRole.toLowerCase() === 'main');
    } catch (_) { return false; }
  }
  window.rsdTrack = function (name, params) {
    if (!permitted()) return;
    if (typeof window.gtag === 'function') window.gtag('event', name, params);
    else { window.dataLayer = window.dataLayer || []; window.dataLayer.push({event:name, ...params}); }
    if (typeof window.fbq === 'function') {
      if (name === 'generate_lead') window.fbq('track', 'Lead', params);
      else if (name === 'contact') window.fbq('track', 'Contact', params);
    }
  };
  function init() {
    const query = new URLSearchParams(location.search);
    document.querySelectorAll('[data-utm]').forEach(input => { input.value = (query.get(input.dataset.utm) || '').slice(0, 200); });
    document.addEventListener('click', event => {
      const link = event.target.closest('a[href]');
      if (!link) return;
      const href = link.getAttribute('href');
      if (href.includes('wa.me/') || href.includes('api.whatsapp.com/')) window.rsdTrack('contact', {method:'whatsapp', context:link.dataset.rsdContext || 'site'});
      else if (href.startsWith('mailto:')) window.rsdTrack('contact', {method:'email'});
      else if (href === '#rsd-formulario') window.rsdTrack('begin_lead', {context:link.dataset.rsdContext || 'site'});
    });
    const form = document.getElementById('RsdDiagnosticForm');
    form?.addEventListener('submit', () => {
      try { if (form.checkValidity() && permitted()) sessionStorage.setItem('rsd_pending_lead', String(Date.now())); } catch (_) { /* Storage may be disabled. */ }
    });
    if (document.querySelector('[data-rsd-success]')) {
      try {
        const pending = Number(sessionStorage.getItem('rsd_pending_lead'));
        sessionStorage.removeItem('rsd_pending_lead');
        if (pending && Date.now() - pending < 3600000) window.rsdTrack('generate_lead', {form:'diagnostico'});
      } catch (_) { /* The form still works without analytics. */ }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
